import { MapPin } from "lucide-react";
import { Input } from "@/shared/components/ui/input";
import { SectionCard, FormRow } from "./DepositUI";

export default function BillingAddressSection({
  form,
  updateField,
  validateField,
  errors,
  fieldRefs,
}) {
  return (
    <SectionCard icon={MapPin} title="Billing Address">
      <div className="space-y-4">
        <FormRow
          id="address"
          label="Street Address *"
          error={errors.address}
        >
          <Input
            id="address"
            ref={(el) => (fieldRefs.current.address = el)}
            value={form.address}
            onChange={(e) => updateField("address", e.target.value)}
            onBlur={(e) => validateField("address", e.target.value)}
            placeholder="123 Main Street, Block A"
            maxLength={200}
            className="h-11 rounded-xl"
          />
        </FormRow>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <FormRow id="city" label="City *" error={errors.city}>
            <Input
              id="city"
              ref={(el) => (fieldRefs.current.city = el)}
              value={form.city}
              onChange={(e) =>
                updateField(
                  "city",
                  e.target.value.replace(/[^a-zA-Z\s]/g, ""),
                )
              }
              onBlur={(e) => validateField("city", e.target.value)}
              autoComplete="address-level2"
              placeholder="Karachi"
              maxLength={100}
              className="h-11 rounded-xl"
            />
          </FormRow>

          <FormRow
            id="state"
            label="State / Province *"
            error={errors.state}
          >
            <Input
              id="state"
              ref={(el) => (fieldRefs.current.state = el)}
              value={form.state}
              onChange={(e) =>
                updateField(
                  "state",
                  e.target.value.replace(/[^a-zA-Z\s]/g, ""),
                )
              }
              onBlur={(e) => validateField("state", e.target.value)}
              autoComplete="address-level1"
              placeholder="Sindh"
              maxLength={100}
              className="h-11 rounded-xl"
            />
          </FormRow>

          <FormRow
            id="postcode"
            label="Postal Code *"
            error={errors.postcode}
          >
            <Input
              id="postcode"
              ref={(el) => (fieldRefs.current.postcode = el)}
              value={form.postcode}
              onChange={(e) =>
                updateField(
                  "postcode",
                  e.target.value.replace(/[^0-9]/g, ""),
                )
              }
              onBlur={(e) => validateField("postcode", e.target.value)}
              placeholder="75500"
              maxLength={20}
              className="h-11 rounded-xl"
            />
          </FormRow>
        </div>
      </div>
    </SectionCard>
  );
}
